module.exports = __webpack_public_path__ + "static/media/Kissen_60x40.74d793a9.png";